import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function BackgroundChatIframe() {
  const iframeRef = useRef(null);
  const childReadyRef = useRef(false);
  const activeConversationRef = useRef(null); // ✅ Track active conversation
  const location = useLocation();

  // 🔌 Listen for messages from parent
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://production.d2kwn1gtzvjggd.amplifyapp.com") return;

      const { type, payload } = event.data || {}; // ✅ destructure type and payload

      if (type === "CHAT_READY") {
        childReadyRef.current = true;
        console.log("Chat iframe ready");
      }

      if (type === "CURRENT_CONVERSATION") {
        activeConversationRef.current = payload?.conversationId || null;
        console.log(
          "Active conversation updated:",
          activeConversationRef.current
        );
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // 🌍 Expose global postMessage helper
  useEffect(() => {
    window.postMessageToChat = (msg) => {
      if (!iframeRef.current?.contentWindow) return;

      if (!childReadyRef.current) {
        setTimeout(() => window.postMessageToChat(msg), 300);
        return;
      }

      iframeRef.current.contentWindow.postMessage(
        msg,
        "https://production.d2kwn1gtzvjggd.amplifyapp.com"
      );
    };
  }, []);

  const isMessagePage = location.pathname === "/message";

  return (
    <div className={`chatIframeRoot ${isMessagePage ? "visible" : "hidden"}`}>
      <iframe
        ref={iframeRef}
        src="https://production.d2kwn1gtzvjggd.amplifyapp.com"
        title="chat-background"
        className="chatIframe"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
